export default __webpack_public_path__ + "static/media/PDV CAIXA.37159f48.png";